var _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCollecting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6918 8.47852L10.4262 8.48492C9.97817 8.48492 9.58137 8.63852 9.29337 8.93292C8.99257 9.23372 8.82617 9.66892 8.82617 10.1617L8.83257 12.1137C8.83897 13.0929 9.49817 13.7713 10.439 13.7713L12.7046 13.7649C13.159 13.7649 13.5494 13.6113 13.8374 13.3233C14.1382 13.0225 14.3046 12.5873 14.3046 12.0945L14.2982 10.1425C14.2982 9.16332 13.639 8.47852 12.6918 8.47852Z",
    fill: "#25B7FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.30617 6.92417C9.59417 7.20577 9.97817 7.35297 10.4262 7.35297H12.7046C13.6646 7.34657 14.3046 6.67456 14.3046 5.67616L14.2982 3.89056C14.2982 2.91136 13.639 2.22656 12.6918 2.22656L10.4262 2.23296C9.97817 2.23296 9.58777 2.38656 9.29337 2.68096C8.99257 2.98176 8.82617 3.41696 8.82617 3.90976L8.83257 5.69536C8.83897 6.18816 9.00537 6.62336 9.30617 6.92417Z",
    fill: "#25B7FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0523 11.0596H12.0763C12.3451 11.0596 12.5563 10.8485 12.5563 10.5796C12.5563 10.3172 12.3451 10.0996 12.0763 10.0996H11.0523C10.7899 10.0996 10.5723 10.3172 10.5723 10.5796C10.5723 10.8485 10.7899 11.0596 11.0523 11.0596Z",
    fill: "#25B7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0763 3.8457H11.0523C10.7899 3.8457 10.5723 4.0633 10.5723 4.3257C10.5723 4.5945 10.7899 4.8057 11.0523 4.8057H12.0763C12.3451 4.8057 12.5563 4.5945 12.5563 4.3257C12.5563 4.0633 12.3451 3.8457 12.0763 3.8457Z",
    fill: "#25B7FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.00818 4.13477H3.74258C3.26898 4.14117 2.86578 4.31397 2.58418 4.60837C2.30258 4.90917 2.14258 5.31877 2.14258 5.81157L2.14898 11.9619C2.14898 12.4547 2.31538 12.8899 2.61618 13.1907C2.90418 13.4723 3.29458 13.6195 3.73618 13.6195H6.02098C6.96177 13.6131 7.62097 12.9219 7.61457 11.9427V5.79877C7.61457 5.30597 7.44177 4.87077 7.14097 4.56997C6.85297 4.28197 6.44977 4.14117 6.00818 4.13477Z",
    fill: "#25B7FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36477 6.91314H5.39517C5.65757 6.91314 5.87517 6.70193 5.87517 6.43313C5.87517 6.17073 5.65757 5.95312 5.39517 5.95312H4.36477C4.10237 5.95312 3.88477 6.17073 3.88477 6.43313C3.88477 6.70193 4.10237 6.91314 4.36477 6.91314Z",
    fill: "#25B7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCollecting);
export default __webpack_public_path__ + "static/media/ic-collecting.dc5ee7145c808324f13f807beba9da06.svg";
export { ForwardRef as ReactComponent };